import { Skeleton, SkeletonListCard } from './Skeleton';

/**
 * Loading skeleton for the Accounts page
 */
export function AccountsPageSkeleton() {
  return (
    <>
      {/* HSA Accounts Section Skeleton */}
      <div className="card mb-6">
        <Skeleton height={20} width={180} className="mb-4" />
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <SkeletonListCard key={i} />
          ))}
        </div>
      </div>

      {/* Family Members Section Skeleton */}
      <div className="card">
        <div className="flex items-center justify-between mb-4">
          <Skeleton height={20} width={150} />
          <Skeleton height={36} width={120} />
        </div>
        <div className="space-y-4">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <Skeleton height={18} width="30%" />
                    <Skeleton height={20} width={60} />
                  </div>
                  <Skeleton height={14} width="50%" />
                </div>
                <Skeleton variant="circular" width={32} height={32} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
